import React from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';

/**
 * Name label for an icon in the collapsed sidebar rail.
 *
 * Rendered in a portal, outside the sidebar: the old label was an absolutely positioned span inside
 * the nav, which is overflow-y:auto, so even invisible it widened the 76px rail to 190px and gave
 * the menu a sideways scrollbar. A portal takes no room in the sidebar at all.
 *
 * Needs a <Tooltip.Provider> above it (Sidebar provides one). `disabled` hides it, e.g. while a
 * popover from the same icon is open.
 */
export default function RailTooltip({ label, children, disabled = false }) {
  return (
    <Tooltip.Root open={disabled ? false : undefined}>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content side="right" align="center" sideOffset={12} className="rail-tip">
          {label}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}

export const RailTooltipProvider = Tooltip.Provider;
